import { Application } from "@hotwired/stimulus";
// add ons
import { controllers } from "@joemasilotti/bridge-components";
import LocalTime from "local-time";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

export { application };

// add ons
application.load(controllers);
LocalTime.start();
